import { useRedirectToLogin, useUser } from "@shuttlerock/auth";
import { Routes } from "@shuttlerock/router";
import { useParams } from "react-router";
import { useTranslation } from "../../i18n";
import type { AccessDeniedData } from "../RouteErrorBoundary/types";
import { ErrorPage } from "./ErrorPage";

export function AccessDeniedPage(props: AccessDeniedData) {
  const params = useParams();

  return params.projectKey ? <ForProject /> : <General {...props} />;
}

function ForProject() {
  const { t } = useTranslation("errorPage");
  const { user } = useUser();
  const redirectToLogin = useRedirectToLogin();
  const isLoggedOut = !user?.auth0IntegrationKey;

  return (
    <ErrorPage
      title={t("deniedProject:title")}
      body={t(isLoggedOut ? "deniedProject:loggedOut" : "deniedProject:loggedIn")}
      primaryButton={
        isLoggedOut
          ? {
              text: t("deniedProject:button:primary"),
              onClick: () => redirectToLogin(),
            }
          : undefined
      }
    />
  );
}

function General({ title, message }: AccessDeniedData) {
  const { t } = useTranslation("errorPage");

  return (
    <ErrorPage
      title={title ?? t("denied:title")}
      body={message ?? t("denied:defaultMessage")}
      primaryButton={{
        text: t("denied:button:primary"),
        route: Routes.External.ContactSupport,
      }}
      secondaryButton={{
        text: t("denied:button:secondary"),
        route: Routes.Home,
      }}
    />
  );
}
